import React, { useEffect, useState } from "react";
import socket from "../socket";
import { useAuth } from "../context/AuthContext";

export default function DebugOverlay({ show }) {
  const { user } = useAuth();
  const [sid, setSid] = useState("");
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const onConnect = () => {
      setConnected(true);
      setSid(socket.id);
    };
    const onDisconnect = () => setConnected(false);

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 8,
        right: 8,
        background: "rgba(0,0,0,.75)",
        color: "#fff",
        padding: "8px 12px",
        borderRadius: 8,
        fontSize: 12,
        zIndex: 5000,
      }}
    >
      <div>
        User: {user?.firstName} {user?.lastName} ({user?.role}) {user?.isDev ? "• DEV" : ""}
      </div>
      <div>
        Socket: {connected ? "connected" : "disconnected"} {sid && `(${sid})`}
      </div>
      <div>{new Date().toLocaleTimeString()}</div>
    </div>
  );
}
